import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const productNameTextResolver: FieldResolver = (metadata: Metadata) => {
  let productNameText
  if (!isEmpty(metadata.getProductName())) {
    productNameText = metadata.getProductName()
  }

  if (!productNameText && metadata.getDocHierarchy() !== undefined) {
    const entries = metadata.getDocHierarchy()!.entries!
    const lastLevel = entries[entries.length - 1]
    productNameText = `${lastLevel.key}=${lastLevel.values!.join(' ; ')}`
  }

  return { productNameText } as StreamData
}

export default productNameTextResolver
